import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { DeleteIcon, EditPencilIcon, SettingsMenuVerticalIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { openChangeRolePopup, openRemoveUserPopup } from './slice';
const styledItemCss = "s94el7";
const StyledItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(styledItemCss, props.className)} />);
const actionsCss = "ac5pfuc";
const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
export const ActionsDropdown = ({
  membership
}) => {
  const dispatch = useDispatch();
  const [toggle, Dropdown, isExpanded] = useDropdown();
  return <Actions>
      <IconButton size="small" aria-expanded={isExpanded} title={I18n.t('publisher.components.table.action_menu_for', {
      item: membership.name
    })} onClick={toggle}>
        <SettingsMenuVerticalIcon />
      </IconButton>
      <Dropdown>
        <ViewportDropdownMenu>
          {membership.policy.update && <StyledItem onClick={() => dispatch(openChangeRolePopup(membership))}>
              <EditPencilIcon />
              {I18n.t('publisher.organization.members.change_role')}
            </StyledItem>}
          {membership.policy.destroy && <StyledItem onClick={() => dispatch(openRemoveUserPopup({
          userId: membership.user_id,
          membershipUuid: membership.uuid
        }))}>
              <DeleteIcon />
              {I18n.t('publisher.action.remove')}
            </StyledItem>}
        </ViewportDropdownMenu>
      </Dropdown>
    </Actions>;
};

require("./actions_dropdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./actions_dropdown.js");